module.exports = __webpack_public_path__ + "img/Iso-9001.c306ddb.png";